import {
  ProcessExecutionType,
  ProcessFlowchartPlatformFeatureType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessFlowchartEditorConfigurator} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorConfigurator';
import {FEATURE_OVERRIDES_FOR_EDITOR_MODE} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';

import {ExecutionEditorMode} from './ExecutionFlowchartPaneTypes';

/** Clones the base configurator with platform features overridden for the given execution editor mode. */
export function buildExecutionEditorConfigurator(
  base: ProcessFlowchartEditorConfigurator,
  editorMode: ExecutionEditorMode
): ProcessFlowchartEditorConfigurator {
  const features = new Map(base.platformFlowchartFeatures);
  const overrides = FEATURE_OVERRIDES_FOR_EDITOR_MODE[editorMode];
  for (const platformFeature of Object.values(ProcessFlowchartPlatformFeatureType)) {
    const override = overrides[platformFeature];
    if (override != null) {
      features.set(platformFeature, override);
    }
  }
  return new ProcessFlowchartEditorConfigurator(
    base.flowchartTypeName,
    [ProcessExecutionType.FLOWCHART],
    features
  );
}
